import { type ISurveyNpsGroup } from 'entities/Surveys/api/types'

export const getNpsGroupByScore = (score: number): ISurveyNpsGroup => {
  if (score >= 9) return 'promoter'
  if (score >= 7) return 'passive'
  return 'detractor'
}
